import React, { useState } from 'react'
import { useAppSelector } from '../../../../../../app/hooks'
import { InitState } from '../../../../../../redux/reducers/root/initialState'
import { selectHasRequiredAddressForValuation } from '../../../../../../redux/selectors/insertionSelectors'
import { useIsRecommendedPriceEnabled } from '../../../UseIsRecommendedPriceEnabled'
import { RentPriceCheck } from './rent-price-check/RentPriceCheck'
import { RentPriceCheckSkeleton } from './rent-price-check/rent-price-check-skeleton/RentPriceCheckSkeleton'
import { MissingRequiredDataNotification } from './missing-required-data-notification/MissingRequiredDataNotification'
import { hasRentIndexBenchmarkData } from './rent-price-check/price-benchmark/usePriceBenchmarkData'
import { useLoadRentControlData } from './useLoadRentControlData'
import { useLoadRentIndexData } from './useLoadRentIndexData'
import { useLoadRentValuationData } from './useLoadRentValuationData'
import { useLoadPriceMaximizerData } from '../../../../../common/display/priceMaximizer/useLoadPriceMaximizerData'

export function RecommendedPriceNotification() {
  const [isRentPriceCheckExpanded, setIsRentPriceCheckExpanded] = useState(false)
  const isRecommendedPriceEnabled = useIsRecommendedPriceEnabled()
  const { minValue, maxValue, recommendedValue, isPending } = useAppSelector(
    (state: InitState) => state.valuationFeature
  )
  const rentControlApplies = useAppSelector((state: InitState) => state.rentControlFeature.rentControlApplies)
  const { savedSearches, similarObjects } = useAppSelector((state: InitState) => state.priceMaximizerFeature)
  const rentIndexResult = useAppSelector((state: InitState) => state.rentIndexFeature)
  const insertionData = useAppSelector((state: InitState) => state.insertionFeature.insertionData)
  const hasRequiredAddressData = useAppSelector(selectHasRequiredAddressForValuation)
  const hasValuationBenchmarkData = minValue !== undefined && maxValue !== undefined && recommendedValue !== undefined

  useLoadRentValuationData(insertionData, isRecommendedPriceEnabled)
  useLoadRentIndexData(insertionData, isRecommendedPriceEnabled)
  useLoadRentControlData(insertionData, isRecommendedPriceEnabled)
  useLoadPriceMaximizerData(insertionData, isRecommendedPriceEnabled && hasRequiredAddressData)

  if (!isRecommendedPriceEnabled) {
    return null
  }

  if (isPending || rentIndexResult.status === 'pending') {
    return (
      <div className='grid-item one-whole'>
        <RentPriceCheckSkeleton />
      </div>
    )
  }

  if (!hasRequiredAddressData) {
    return (
      <div className='grid-item one-whole'>
        <MissingRequiredDataNotification />
      </div>
    )
  }

  if (!hasValuationBenchmarkData && !hasRentIndexBenchmarkData(rentIndexResult)) {
    return null
  }

  return (
    <div className='grid-item one-whole'>
      <RentPriceCheck
        price={insertionData.price}
        livingSpace={insertionData.livingSpace}
        room={insertionData.room}
        constructionYear={insertionData.constructionYear}
        rentControlApplies={rentControlApplies}
        savedSearches={savedSearches}
        similarObjects={similarObjects}
        isExpanded={isRentPriceCheckExpanded}
        onExpandedChange={setIsRentPriceCheckExpanded}
      />
    </div>
  )
}
